"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = require("../../Button");
exports.ModalMessage = styled_components_1.default.div `
  padding: 30px;
  margin-top: 30%;
`;
exports.ModalMessageHeader = styled_components_1.default.div `
  margin: 20px;

  i {
      font-size: 50pt;
      margin-bottom: 30px;
  }
`;
exports.ModalMessageBody = styled_components_1.default.div `
  color: ${props => props.theme.colors.gray};
  font-weight: 300;
  font-size: 12pt;
`;
exports.ModalMessageLink = styled_components_1.default(Button_1.Button) `
  margin-top: 20px;
  font-size: 12pt;
  text-transform: uppercase;
`;
